// extracted by mini-css-extract-plugin
module.exports = {"successIcon":"customPreIcon_successIcon__31AhO","warningIcon":"customPreIcon_warningIcon__2H1_q","dangerIcon":"customPreIcon_dangerIcon__17m50"};